import { createFileRoute } from '@tanstack/react-router';
import { createGroupBroadcastDetailRoute } from '@/lib/route-factories/group-broadcast-route';

export const Route = createFileRoute(
  '/_authed/groups/$id/admin/broadcasts/$broadcastId/',
)(
  createGroupBroadcastDetailRoute({
    kind: 'space',
    fromId: '/_authed/groups/$id/admin/broadcasts/$broadcastId/',
  }),
);
